<template>
    <div>
        <transition name="fade">
            <div
                v-if="isVisibleSideBarGenericModal"
                class="modal-generic-backdrop"
            ></div>
        </transition>
        <div
            class="modal modal-side modal-right modal-command primary fade"
            aria-hidden="true"
            :class="{ 'show': isVisibleSideBarGenericModal === true }"
        > 
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="header-link">
                            <div class="link">
                                <a
                                    class="link-header"
                                    @click="closeModal"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="24"
                                        viewBox="0 0 25 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M12.5 19L5.5 12M5.5 12L12.5 5M5.5 12H19.5"
                                            stroke="#CACACA"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </a>
                            </div>
                        </div>
                        <div class="header-button">
                            <div class="button" @click="closeModal">
                                <button
                                    type="button"
                                    class="btn btn-block btn-header"
                                    data-bs-dismiss="modal"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M5.71875 4.28087C5.31899 3.89979 4.67835 3.90746 4.28783 4.29798C3.8973 4.6885 3.90478 5.31401 4.30453 5.69508L10.9059 11.988L4.30453 18.2809C3.90478 18.6619 3.8973 19.2874 4.28783 19.678C4.67835 20.0685 5.31899 20.0762 5.71875 19.6951L12.3547 13.3691L18.7808 19.495C19.1806 19.8761 19.8212 19.8684 20.2117 19.4779C20.6023 19.0873 20.5948 18.4618 20.195 18.0808L13.8036 11.988L20.195 5.89518C20.5948 5.51411 20.6023 4.8886 20.2117 4.49808C19.8212 4.10755 19.1806 4.09989 18.7808 4.48097L12.3547 10.6068L5.71875 4.28087Z"
                                            fill="#C4C4C4"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-header">
                        <div class="header-text">
                            <div class="title">
                                <h2>{{ currentCrew?.name }}</h2>
                            </div>
                            <div class="desc">
                                <p>{{ currentCrew?.description }}</p>
                            </div>
                        </div>
                    
                    </div>
                    <div class="modal-body no-scrollbar">
                        <div class="body-content">
                            <div v-if="loading" class="loading-dots">
                                <div class="dot-flashing"></div>
                            </div>
                            <div v-else class="content-form">
                                <div v-for="(field, index) in fieldsModalGeneric" :key="index" class="form-group">
                                    <div class="form-label">
                                        <label>{{ field.title }}</label>
                                    </div>

                                    <div v-if="field.type === 1" class="group-wrapper primary">
                                        <div class="form-input">
                                            <input 
                                                type="text"
                                                class="form-control"
                                                :placeholder="field.description"
                                                v-model="formData[field.property]"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="field.type === 2" class="group-wrapper primary">
                                        <div class="form-input">
                                            <input 
                                                type="date"
                                                class="form-control"
                                                v-model="formData[field.property]"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="field.type === 3" class="group-wrapper primary">
                                        <div class="form-input">
                                            <input 
                                                type="number"
                                                class="form-control"
                                                :placeholder="field.description"
                                                v-model="formData[field.property]"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="field.type === 4" class="group-wrapper primary">
                                        <div class="form-input">
                                            <input 
                                                type="number"
                                                step="0.01"
                                                class="form-control"
                                                :placeholder="field.description"
                                                v-model="formData[field.property]"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="field.type === 5" class="group-wrapper primary">
                                        <div class="form-textarea">
                                            <textarea
                                                class="form-control"
                                                :placeholder="field.description"
                                                rows="7"
                                                v-model="formData[field.property]"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div v-if="field.type === 6" class="group-wrapper primary">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="formData[field.property]"
                                            />
                                        </div>
                                    </div>

                                    <div v-if="field.type === 7" class="group-wrapper primary dark">
                                        <div class="form-select ">
                                            <select 
                                                class="form-control dark"
                                                v-model="formData[field.property]"
                                            >
                                                <option value="">Selecione uma opção</option>
                                                <option v-for="option in field.options" :key="option.value" :value="option.value">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div class="form-button">
                                    <div class="button">
                                        <button
                                            type="button"
                                            class="btn btn-block btn-form secondary"
                                        @click="closeModal"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                    <div class="button">
                                        <button
                                            type="button"
                                            class="btn btn-block btn-form primary"
                                            @click="handleSave"
                                        >
                                            Enviar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'ModalGeneric',
        data() {
            return {
                formData: {},
                loading: false
            }
        },
        computed: {
            ...mapState(['isVisibleSideBarGenericModal', 'fieldsModalGeneric', 'currentCrew'])
        },
        methods: {
            ...mapActions(['storeIsVisibleSideBarGenericModal', 'storeCurrentRunIa']),
            handleCancel() {
                this.$emit('cancel');
            },
            handleSave() {
                this.loading = true;
                const payload = {
                    "id": 0,
                    "type_engine": 1,
                    "crew_id": this.currentCrew.id,
                    "request_type": 1,
                    "status": 0,
                    "parameters": this.fieldsModalGeneric.map(field => ({
                        "type": 1,
                        "property": field.property,
                        "value": this.formData[field.property]
                    }))
                };
                
                console.log(payload);
                this.storeCurrentRunIa({currentRunIa: payload});
                this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: false });
                this.$router.push('/chat');
                this.loading = false;
            },
            closeModal() {
                this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: false });
            }
        },
        created() {
            if (Array.isArray(this.fieldsModalGeneric)) {
                this.fieldsModalGeneric.forEach(field => {
                    this.formData[field.property] = '';
                });
            }
        },
        mounted() {
            this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: false });
        }
    }
</script>
<style scoped>
.desc p {
    color: white;
}

.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}

.dot-flashing {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29BBFF;
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.5s;
}

.dot-flashing::before, .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-flashing::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29BBFF;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0s;
}

.dot-flashing::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29BBFF;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dot-flashing {
    0% {
        background-color: #29BBFF;
    }
    50%, 100% {
        background-color: rgba(41, 187, 255, 0.2);
    }
}

.form-control.dark {
    background-color: #212226;
    color: #ababab;
    border: none;
}

.form-control.dark option {
    background-color: #1E1E1E;
    color: #ababab;
}

.group-wrapper.dark {
    background-color: #1E1E1E;
    border-radius: 4px;
}
.form-select {
    background-color: #212226;
}

.modal-body.no-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.modal-body.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.header-link .link {
    cursor: pointer;
}

.modal-generic-backdrop {
    position: fixed;
    z-index: 1040;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(120deg, rgba(33, 34, 38, 0.95) 0%, rgb(255 255 255 / 25%) 100%);
    transition: opacity 0.3s;
    opacity: 1;
    pointer-events: auto;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>